import classNames from 'classnames';
import ChairSvg from 'src/components/svg/ChairSvg';
import styles from './LoadingIndicator.module.css';

//#region [Props]
type LoadingIndicatorProps = {
    className?: string;
    position?: "AbsoluteCenter" | "TopCenter" | "InlineCenter";
    size?: "large" | "small";
    label?: string;
};
//#endregion

//#region [Component]
export default function LoadingIndicator({ className, position = "AbsoluteCenter", size = "large", label }: LoadingIndicatorProps) {
    const speed = 2;
    return <div
        className={classNames(styles.SLoadingIndicator, className, {
            [styles.topCenter]: position === 'TopCenter',
            [styles.inlineCenter]: position === 'InlineCenter',
            [styles.small]: size === 'small'
        })}
        aria-label={label}
        style={{
            '--speed': `${speed}s`,
            '--delay-2': `${speed / 8}s`,
            '--delay-3': `${speed / 4}s`,
            '--ICONCOLOR_OVERRIDE': 'var(--palette-lilla-mørk-hovedfarge)'
        } as React.CSSProperties}
    >
        <ChairSvg className={styles.SChairSvg} isFilled />
        {size === 'large' && <>
            <ChairSvg className={styles.SChairSvg} isFilled />
            <ChairSvg className={styles.SChairSvg} isFilled />
        </>}
    </div>;
}
//#endregion